import { IonCol, IonGrid, IonRow } from '@ionic/react'
import { _dict, _homeNodePath, _host } from './constants';
import { useGlobalStore } from './stateManagement/globalZustand';
import { useState } from 'react';
 
function ChooseLang() {
    const [chosenLang, setChosenLang] = useState<string|null>(null);
    const [didChooseLang, setDidChooseLang] = useState(false); 
    const { updateLang } = useGlobalStore();

    const handleUpdateLang = (lang: string) => {
        setChosenLang(lang);
        updateLang(lang);
    }

    return (
    <IonGrid fixed={true}>
        <IonRow>
            <IonCol className="ion-text-center">
            <a href={_host+"/welcome"}>
                <img src="assets/icon/icon.png" alt="Web App Logo" width="60px" style={{ marginTop: '1rem', borderRadius: '20px' }} />
            </a>
            </IonCol>
        </IonRow> 
        <IonRow><IonCol><div style={{height:"10px"}}></div></IonCol></IonRow>
        {chosenLang === null ? <><IonRow className="ion-text-center">
            <IonCol>
                <b>Select your preferred language</b>
            </IonCol>
        </IonRow>
        <IonRow><IonCol><div style={{height:"20px"}}></div></IonCol></IonRow>
        <IonRow>
            <IonCol></IonCol>
            <IonCol size="2">
                <div className="lang" onClick={() => {handleUpdateLang("it");}}>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 3 2'><path fill='#009246' d='M0 0h1v2H0z'/><path fill='#fff' d='M1 0h1v2H1z'/><path fill='#ce2b37' d='M2 0h1v2H2z'/></svg>
                </div>
            </IonCol>
            <IonCol></IonCol>
        </IonRow>
        <IonRow>
            <IonCol></IonCol>
            <IonCol size="2">
            <div className="lang" onClick={() => {handleUpdateLang("en"); }}>
                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 60 30'><clipPath id='a'><path d='M0 0v30h60V0z'/></clipPath><clipPath id='b'><path d='M30 15h30v15zv15H0zH0V0zV0h30z'/></clipPath><g clipPath='url(#a)'><path d='M0 0v30h60V0z' fill='#012169'/><path d='m0 0 60 30m0-30L0 30' stroke='#fff' strokeWidth='6'/><path d='m0 0 60 30m0-30L0 30' clipPath='url(#b)' stroke='#C8102E' strokeWidth='4'/><path d='M30 0v30M0 15h60' stroke='#fff' strokeWidth='10'/><path d='M30 0v30M0 15h60' stroke='#C8102E' strokeWidth='6'/></g></svg>
            </div>
            </IonCol>
            <IonCol></IonCol>
        </IonRow>
        <IonRow>
            <IonCol></IonCol>
            <IonCol size="2">
            <div className="lang" onClick={() => {handleUpdateLang("de"); }}>
            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 5 3'><path d='M0 0h5v3H0z'/><path fill='#D00' d='M0 1h5v2H0z'/><path fill='#FFCE00' d='M0 2h5v1H0z'/></svg>
            </div>
            </IonCol>
            
            <IonCol></IonCol>
        </IonRow></> : <>
        <IonRow className="ion-text-center">
            <IonCol >
                <b>{_dict.thanksForChoosingLang[chosenLang]}!</b>
            </IonCol>
        </IonRow>
        <IonRow className="ion-text-center">
            <IonCol>
                <a href={"/welcome"}>{_dict.proceed[chosenLang]}</a>
            </IonCol>
        </IonRow>
        </>
        }
    </IonGrid>
  )
}

export default ChooseLang